const PersonalData = {
  firstName: {
    value: "",
    type: "text",
    label: "First Name",
    errorMsg: "This is a mandatory field",
    readonly: true,
    checkButton: true,
    class: "capital mb-3 col-12 form-group mt-20",
    checkForm: true,
    checkReadOnly: true,
    validation: {
      require: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  },
  lastName: {
    value: "",
    type: "text",
    label: "Last Name",
    checkForm: true,
    checkButton: true,
    class: "capital mb-3 col-12 form-group mt-20",
    checkReadOnly: true,
    errorMsg: "This is a mandatory field",
    readonly: true,
    validation: {
      require: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  },
  email: {
    value: "",
    label: "Email",
    type: "text",
    readonly: true,
    checkButton: true,
    checkForm: true,
    errorMsg: "This is a mandatory field.",
    noAstrics: true,
    validation: {
      require: true
    },
    maxLength: "255",
    valid: true
  }
};

export default PersonalData;
